<template>
  <div class="newListPage">
    <mt-header title="企业介绍">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="mintHeader"></div>
    <div class="detailsContent">
      <ul class="newUl">
        <li class="newLi" v-for="(item,i) in 10" :key="i">
          <div class="newLiL">
            <h6>cippe2021北京石油展全球启动！cippe2021北京石油展全球启动！</h6>
            <p>
              <span>2020-09-24 17:00:00</span>
              <span><i class="iconfont icon-yanjing"></i>2631</span>
            </p>
          </div>
          <div class="newLiR">
            <img src="https://picsum.photos/id/318/400/240" alt="" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import "mint-ui/lib/header/style.css"
export default {
  components:{
    'mt-header':Header,
  },
}
</script>

<style scoped>
  .newListPage{
    height: 100%;
    background-color: white;
    overflow: hidden;
  }
  .mint-header{
    height: 40px;
    background-color: #008baf;
    position: relative;
    z-index: 10;
  }
  .newLi{
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
    border-bottom: 1px solid #f2f2f2;
  }
  .newLiL{
    width: 225px;
  }
  .newLiL h6{
    color: #666666;
    font-size: 14px;
    line-height: 23px;
    margin-bottom: 10px;
    margin-top: 5px;
  }
  .newLiL p{
    color: #999999;
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
  }
  .newLiL span{
    vertical-align: middle;
  }
  .newLiL i{
    vertical-align: middle;
    margin-right: 3px;
  }
  .newLiR{
    width: 120px;
    height: 80px;
  }
  
</style>